var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 20.5C3.95 20.5 3.47933 20.3043 3.088 19.913C2.696 19.521 2.5 19.05 2.5 18.5V6.5C2.5 5.95 2.696 5.47933 3.088 5.088C3.47933 4.696 3.95 4.5 4.5 4.5H20.5C21.05 4.5 21.521 4.696 21.913 5.088C22.3043 5.47933 22.5 5.95 22.5 6.5V18.5C22.5 19.05 22.3043 19.521 21.913 19.913C21.521 20.3043 21.05 20.5 20.5 20.5H4.5ZM12.5 13.325C12.5833 13.325 12.6707 13.3123 12.762 13.287C12.854 13.2623 12.9417 13.225 13.025 13.175L20.1 8.75C20.2333 8.66667 20.3333 8.56267 20.4 8.438C20.4667 8.31267 20.5 8.175 20.5 8.025C20.5 7.69167 20.3583 7.44167 20.075 7.275C19.7917 7.10833 19.5 7.11667 19.2 7.3L12.5 11.5L5.8 7.3C5.5 7.11667 5.20833 7.11233 4.925 7.287C4.64167 7.46233 4.5 7.70833 4.5 8.025C4.5 8.19167 4.53333 8.33733 4.6 8.462C4.66667 8.58733 4.76667 8.68333 4.9 8.75L11.975 13.175C12.0583 13.225 12.146 13.2623 12.238 13.287C12.3293 13.3123 12.4167 13.325 12.5 13.325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1cdc9f6aaadea3ad01747f10ec089881.svg";
export { ForwardRef as ReactComponent };